import AutoCombineView from "./Entries/AutoCombineView";

export default function EntriesView() {
	return <AutoCombineView />;
}
